import type { EntityConfig } from '../types'

export const velocityEntity: EntityConfig = {
  id: 'velocity',
  displayName: 'Velocity Schedule',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'draft', label: 'Draft' },
      { value: 'archived', label: 'Archived' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'draft', label: 'Draft', color: 'neutral' },
      { value: 'archived', label: 'Archived', color: 'warning' },
    ],
    mappings: {
      all: [],
      active: ['active'],
      draft: ['draft'],
      archived: ['archived'],
    },
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['search', 'status'],
}
